export const playbackUrlAt = (playerUrl: string, startMs: number, autoplay = false): string => {
  const url = new URL(playerUrl);
  if (startMs > 0) url.searchParams.set("startTime", `${Math.floor(startMs / 1_000)}s`);
  else url.searchParams.delete("startTime");
  if (autoplay) url.searchParams.set("autoplay", "true");
  else url.searchParams.delete("autoplay");
  return url.toString();
};
